<div class="container-product-carousel" *ngIf="productCarousel">
  <p class="title text-center ff-bold h4 m-b-20">
    {{ productCarousel.title }}
  </p>

  <p-carousel
    role="region"
    [value]="products"
    [numVisible]="4"
    [numScroll]="4"
    [circular]="true"
    class="custom-carousel product-carousel"
    [responsiveOptions]="responsiveOptions"
  >
    <ng-template pTemplate="item" let-item let-i="index">
      <div [attr.aria-hidden]="false" class="custom-item">
        <product-card [product]="item" [isCarousel]="true"></product-card>
      </div>
    </ng-template>

    <ng-template pTemplate="previousicon" let-item>
      <span class="material-symbols-outlined">arrow_back_ios_new</span>
    </ng-template>

    <ng-template pTemplate="nexticon" let-item>
      <span class="material-symbols-outlined">arrow_forward_ios</span>
    </ng-template>
  </p-carousel>
</div>
